// extracted by mini-css-extract-plugin
export default {"zoomModal":"u3-z","image":"v3-z","button":"w3-z","isOverlayShown":"x3-z"};